import { Route, Routes, Navigate } from "react-router-dom";
// App Routes
import appRoutes from "./app/app_routes";

function App() {
  const configAppRoutes = appRoutes;

  const getAppRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      return (
        <Route
          exact
          path={route.route}
          element={route.component}
          key={route.key}
          title={route.name}
        />
      );
    });

  return (
    <div>
      <Routes>
        {getAppRoutes(configAppRoutes)}
        <Route path="*" element={<Navigate to="/error" />} />
      </Routes>
    </div>
  );
}

export default App;
